import { useCallback, useContext, useMemo } from 'react';
import { AuthContext } from '../context/AuthContext';

/**
 * Returns { can } — a STABLE reference across renders as long as `user` is unchanged.
 * Unstable references caused an infinite re-render loop (polling backend hundreds of
 * times per second) when consumers used `can` in useEffect/useCallback dep arrays.
 */
export function usePermission() {
  const { user } = useContext(AuthContext);

  const perms = useMemo(() => {
    const list = user?.permissions;
    return list instanceof Set ? list : new Set(Array.isArray(list) ? list : []);
  }, [user]);

  const can = useCallback((permission) => perms.has(permission), [perms]);

  return { can };
}
